const getApiBaseUrl = () => {
  // For server-side rendering or tests
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BASE_URL || 'https://api.staging.chooseandwork.com/api/v1/';
  }
  
  const hostname = window.location.hostname;
  
  if (hostname.includes('localhost') || 
      hostname.includes('new-staging.chooseandwork.') || hostname.includes('staging.chooseandwork.')) {
    return 'https://api.staging.chooseandwork.com/api/v1/';
  } else if (hostname.includes('new.chooseandwork.') || 
      hostname.includes('www.chooseandwork.')) {
    return 'https://api.chooseandwork.com/api/v1/';
  }
  
  // Default fallback
  return 'https://api.staging.chooseandwork.com/api/v1/';
};

// Export the base URL
export const API_BASE_URL = getApiBaseUrl();